import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MUIButton from '@material-ui/core/Button';
import { LoadingSpinnerButton } from '../Loaders/LoadingSpinner';

class Button extends Component {
  constructor(props) {
    super(props);
    this.state = { pending: false };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  onClick = async (...args) => {
    if (this.props.onClick) {
      try {
        this.setState({ pending: true });
        await this.props.onClick(...args);
      }
      finally {
        if (this._isMounted) {
          this.setState({ pending: false });
        }
      }
    }
  }

  render() {
    const { color, disabled, fullWidth, isLoading, className, type, variant } = this.props;
    return (
      <MUIButton
        color={color}
        className={className}
        disabled={this.state.pending || disabled || isLoading}
        fullWidth={fullWidth}
        onClick={this.onClick}
        type={type}
        variant={variant}
      >
        {((this.state.pending || isLoading) ? LoadingSpinnerButton() : this.props.children)}
      </MUIButton>
    );
  }
}

Button.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

Button.defaultProps = {
  disabled: false,
};

export default Button;
